// prettier-ignore
const ALL = [
  { id: 0, name: 'male', 'pt-BR': 'Masculino', 'en-US': 'Male' },
  { id: 1, name: 'female', 'pt-BR': 'Feminino', 'en-US': 'Female' }
]

export function all() {
  return [...ALL]
}

export function findById(id) {
  return ALL.find(gender => gender.id === +id)
}

export function findByName(name) {
  return ALL.find(gender => gender.name === name)
}
